<form class="form" [formGroup]="form" (ngSubmit)="submit()">
  <div class="form__title">{{ instructionTypeData[currentType].title | translate }}</div>
  <div class="form__description">{{ instructionTypeData[currentType].description | translate }}</div>

  <div class="input-container">
    <app-form-input class="input-item" [label]="'t.enter-your-email' | translate" [control]="form.get('email')">
      <input class="input input--simple" type="text" name="email" formControlName="email">
    </app-form-input>
  </div>

  <div class="submit-container">
    <button class="btn small" [loading]="loading" type="submit">{{ instructionTypeData[currentType].buttonLabel | translate}}</button>
  </div>
</form>

<!-- <div class="links">
  @if (currentType !== Type.UNLOCK) {
    <div (click)="changeType(Type.UNLOCK);"><span class="link--gradient">{{'t.didnt-receive-unlock-i' | translate}}</span></div>
  }
  @if (currentType !== Type.RESET) {
    <div (click)="changeType(Type.RESET);"><span class="link--gradient">{{'t.forgot-pass' | translate}}</span></div>
  }
  @if (currentType !== Type.CONFIRMATION) {
    <div (click)="changeType(Type.CONFIRMATION);"><span class="link--gradient">{{'t.didnt-receive-confirmation-i' | translate}}</span></div>
  }
</div> -->
